import { render, staticRenderFns } from "./pj-info.vue?vue&type=template&id=eb10a6ac&scoped=true"
import script from "./pj-info.vue?vue&type=script&lang=js"
export * from "./pj-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb10a6ac",
  null
  
)

export default component.exports